export enum Status {
  Loading = 'Loading',
  Error = 'Error',
  Success = 'Success',
}
